import React, { useState, useContext } from 'react';
import { Row, Col, Container } from 'reactstrap';
import classNames from "classnames";
import styles from './GetStarted.module.css';
import { SessionContext } from '../../context/SessionContext';
import ProtectionBanner from '../../assets/images/Vendor/HomeDepot/ProtectionBanner.jpeg';
import EnrollmentModal from '../../components/Modals/Enrollment/Enrollment';
import { ReactComponent as ShieldCheck } from '../../assets/images/Vendor/HomeDepot/Shield-hd1.svg';


const GetStarted = () => {
    const sessionContext = useContext(SessionContext);
    const { accountName } = sessionContext;
    const [showEnrollmentModal, setShowEnrollmentModal] = useState(false);

    const handleShowActionModal = () => {
        setShowEnrollmentModal(true);
    };

    return (
        <>
            <Container fluid className={styles.getStartedContentContainer}>
                <Container className={classNames("mb-4", styles.getStartedInnerContainer)}>
                    <Row> 
                        <Col lg="6" xl="7" className={classNames('text-start order-2 order-xl-1 order-lg-1', styles.getProtectionOuterContainer)}>
                            <h1 className={styles.getStartedHeader}>More Protection. More Money.</h1>
                            <div className={styles.getProtectionContainer}>
                                <p>
                                    Partner with The Home Depot Extended Protection Plans to increase your 
                                    overall profit by adding labor coverage to all your product 
                                    installations. You choose the term and service reimbursement rate 
                                    that works best for you and your customers.
                                </p>
                                <p>
                                    This protection, paired with subsequent renewal campaigns and service 
                                    call reimbursements, will help generate long-term customer relationships 
                                    and revenue years after the initial sale is complete.
                                </p>
                            </div>
                        </Col>
                        <Col lg="6" xl="5" className={classNames("order-1 order-xl-2 order-lg-2 text-right", styles.protectionBannerOuterContainer)}>
                            <div className={styles.protectionBannerContainer}>
                                <img 
                                    src={ProtectionBanner}
                                    className={styles.protectionBanner} 
                                />
                            </div>                            
                        </Col>
                    </Row>
                </Container>
                <Container className={styles.getStartedContainer}>
                    <Row>
                        <Col>
                            <div>
                                <h1 className={styles.getStartedHeader}>HOW TO GET STARTED</h1>
                                <div className={styles.paragraphHD}>
                                    Our user-friendly portal makes selling and managing extended protection plans easy! <br />
                                    Simply enroll, once onboarded you can login to start adding labor plans to all your installations.
                                </div>
                            </div>
                            <div className="m-auto">
                                <button
                                    className={classNames(styles.enrollToday)}
                                    onClick={(e) => handleShowActionModal()}
                                >
                                    Enroll Today
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container className={styles.claimContainer}>
                    <Row>
                        <Col lg="4" xl="4" className="pl-0">
                            <div>
                                <div className={styles.claimHeader}>
                                    <h1>5 YEARS</h1>
                                </div>                            
                                <div className={styles.claimUnderline}></div>
                                <p>
                                    Time allowed to sell extended service agreement after installation
                                </p>
                            </div>
                        </Col>
                        <Col lg="4" xl="4" className={styles.claimColumn}>
                            <div>
                                <div className={styles.claimHeader}>
                                    <ShieldCheck />
                                </div>                            
                                <div className={styles.claimUnderline}></div>
                                <p>
                                    Easy claim submission through our online portal
                                </p>
                            </div>
                        </Col>
                        <Col lg="4" xl="4" className="pr-0">
                            <div>
                                <div className={styles.claimHeader}>
                                    <h1>73.9%</h1>
                                </div>
                                <div className={styles.claimUnderline}></div>
                                <p>
                                    Consumers made their HVAC purchase after consulting at least one online review site
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container className={styles.saveTimeContainer}>
                    <Row>
                        <Col md="4" lg="5" xl="5">
                            <div className={styles.saveTimeLeftContainer}>
                                Save time<br />
                                <div className={styles.saveTimeUnderline}></div>
                                in sales<br />
                                processing
                            </div>
                        </Col>
                        <Col md="8" lg="7" xl="7" className={styles.saveTimeRightContainer}>
                            <div>
                                <h1 className="pt-2">Two Simple Sales Options</h1>
                            </div>
                            <div className={styles.saveTimePara}>
                                <div>1</div>
                                <div className={styles.saveTimePara1}>
                                    Automatically apply pre-selected labor protection to every 
                                    product registration by enrolling in <span className={styles.saveTimeSpan}>Quality Promise</span>, 
                                    eliminate the administrative work.
                                </div>
                            </div>
                            <div className={styles.saveTimePara}>
                                <div>2</div>
                                <div className={styles.saveTimePara2}>
                                    Purchase one contract at a time for individual registrations 
                                    anytime using our simple administration platform.
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>            
            </Container>
            {showEnrollmentModal && (
                <EnrollmentModal
                    isOpen={showEnrollmentModal}
                    centered={true}
                    toggle={() => setShowEnrollmentModal(!showEnrollmentModal)}
                    accountName={accountName}
                />
            )}
        </>
    );
}

export default GetStarted;